<template>  
    <div class="frame-padding">
        <div class="main__panel">
            <div class=" main__panel__header" ref="header">
                <breadcrumb-ms >
                </breadcrumb-ms>
                <slot name="header" ></slot>
            </div>
            <div  v-if="menu != null && menu[0] != undefined && menu[0].no_visible != 1" class="main__panel__memu">
                <div :class="fixed?'main__panel__memu_fixed':absolute?'main__panel__memu_absolute':''">
                    <menu id="menu">
                        <li v-for="item in menu" :key="item.id">
                            <a :href="'/'+item.link.replace(':id',$route.params.path)">{{item.label}}</a>
                        </li>
                    </menu>
                </div>
            </div>
            <div  class="main__body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumbMs from '../common/breadcrumbMs.vue';
import axios from 'axios';
export default{ 
    components:{
        breadcrumbMs
    },
    watch:{
    },
    mounted(){
        axios
            .get('https://mosp51.ru/api/menu?link='+this.$route.path.replace(/[0-9]+$/g, "").replace(/^[//]+|[//]+$/g, ""))
            .then(response=>{
                this.menu = response.data
                this.$emit('set-menu',this.menu)
            })
        window.addEventListener('scroll', this.handleScroll)
        this.handleScroll()
    },
    methods:{
        handleScroll() {
            let height = 161
            if (this.$refs.header != null)
                height = this.$refs.header.offsetHeight

            if(document.querySelector('.main__panel__memu') != undefined && 
               document.querySelector('.main__panel__memu').clientHeight  != undefined &&
               765 >= document.body.clientHeight-window.scrollY
             ){         
                this.absolute = true
                this.fixed = false
                return false
             }


            if (window.scrollY>height){
                this.fixed = true
                // menu.style.top =  '244px'
                this.absolute = false
                return true;
            }
            this.fixed = false
            this.absolute = false
            return false
        }
    },
    data(){
        return{
            menu:[],
            fixed:false,
            absolute:false
        }
    },

}
</script>
<style>
.main__panel{
    display: grid;
    grid-template-areas:"A A A A""B C C C";
    margin-top: 244px !important;
    column-gap:32px;
    grid-template-columns: repeat(4, 1fr);
}
.main__panel__header{
    grid-area:A
}
.main__panel__memu{
    width: 306px;
    position: relative;
    grid-area:B;
    padding-bottom: 100px;
}
.main__panel__memu menu{
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction:column;
    gap:16px
}
.main__panel__memu menu li{
    list-style: none;
}
.main__panel__memu menu li a{
    text-decoration: none;
    color:#175472 ;
}
.main__panel__memu menu li a:hover{
    color:#007BB8 ;
}
.main__panel__memu_fixed{
    width: 306px;
    position: fixed;
    top:244px
   
}
.main__panel__memu_absolute{
    position: absolute;
    width: 306px;
    bottom: 0px;
    padding-bottom: 100px;
}
.main__body{
    grid-area:C;
}
.main__panel h2{
    margin-top: 40px;
    margin-bottom: 64px;
    font-weight: 500;
}
.main__body>div{
    display: flex;
    flex-direction: column;
    gap: 64px;
}
.main__body section>h3{
    scroll-margin-top: 240px;
    margin-top: 0;
    margin-bottom: 40px;
    font-size: 26px;
    color: #0D3041;
    font-weight: 500;
}

@media (max-width: 1000px){
    .breadcrumb-ms{ 
        display: none;
    }
    .main__panel{
        display: flex;
        flex-direction: column;
        margin-top:108px !important;
    } 
    .main__panel h2{
        margin-top: 0;
        margin-bottom: 24px;
    }
    .main__panel__memu_absolute,
    .main__panel__memu_fixed{
        position: static ;
    }
    .main__panel__memu{
        padding: 0;
    }

    .main__body section > h3{
        margin-top: 48px;
        margin-bottom: 32px;
        font-size:22px
    }
    section:last-child {
        margin-bottom: 48px !important;
    }
}
</style>